import Radium from "radium";
import React from "react";
import moment from "moment";

import { remoStyles } from "@common/styles";
import { IAuthorization, AuthorizationType } from "@common/models";

export interface IEditAuthorizationProps {
  closeModal: () => void;
  updateAuthorizations: (authorizations: AuthorizationType[]) => void;
  currentAuthorizations: IAuthorization[];
}

export interface IEditAuthorizationState {
  isBasicUser: boolean;
  isApiUser: boolean;
  isAdminUser: boolean;
}

class EditAuthorization extends React.Component<
  IEditAuthorizationProps,
  IEditAuthorizationState
> {
  constructor(props: IEditAuthorizationProps) {
    super(props);
    this.state = {
      isBasicUser: !!props.currentAuthorizations.filter(
        auth => auth.claim === AuthorizationType.Basic
      )[0],
      isApiUser: !!props.currentAuthorizations.filter(
        auth => auth.claim === AuthorizationType.Api
      )[0],
      isAdminUser: !!props.currentAuthorizations.filter(
        auth => auth.claim === AuthorizationType.Admin
      )[0]
    };
  }

  public render() {
    const remoCancelButtonStyle = {
      ...remoStyles.okButton,
      backgroundColor: "#444"
    };
    const remoContentStyle = { ...remoStyles.text, flexDirection: "column" };

    return (
      <div style={remoStyles.container as any} className="flexList">
        <div style={remoStyles.header as any}>Rediger brukerrettigheter</div>
        <div style={remoContentStyle as any}>
          <div style={remoStyles.checkboxContainer as any}>
            <input
              type="checkbox"
              name="authBasicUser"
              value="basic_user"
              ref="basic_user"
              onChange={e => this.setState({ isBasicUser: e.target.checked })}
              checked={this.state.isBasicUser}
            />
            Basic user
          </div>
          <div style={remoStyles.checkboxContainer as any}>
            <input
              type="checkbox"
              name="authApi"
              value="api"
              ref="api"
              onChange={e => this.setState({ isApiUser: e.target.checked })}
              checked={this.state.isApiUser}
            />
            API-bruker
          </div>
          <div style={remoStyles.checkboxContainer as any}>
            <input
              type="checkbox"
              name="authAdmin"
              value="admin"
              ref="admin"
              onChange={e => this.setState({ isAdminUser: e.target.checked })}
              checked={this.state.isAdminUser}
            />
            Administrator
          </div>
        </div>
        <div
          style={remoStyles.okButton as any}
          onClick={this.updateAuthorizations}
        >
          Lagre
        </div>
        <div
          onClick={this.props.closeModal}
          style={remoCancelButtonStyle as any}
        >
          Avbryt
        </div>
      </div>
    );
  }

  private updateAuthorizations = () => {
    const activeAuthorizations: AuthorizationType[] = [];
    const { currentAuthorizations } = this.props;

    const now = moment();
    const createdDate = now.toISOString();
    const expireDate = now.add(3, "y").toISOString();

    if (this.state.isBasicUser) {
      activeAuthorizations.push(AuthorizationType.Basic);
    }
    if (this.state.isApiUser) {
      activeAuthorizations.push(AuthorizationType.Api);
    }
    if (this.state.isAdminUser) {
      activeAuthorizations.push(AuthorizationType.Admin);
    }

    this.props.updateAuthorizations(activeAuthorizations);
  };
}

export default Radium(EditAuthorization);
